module.exports = "/_next/static/images/kintan-d56beb2e55e35221fd3e6a0a7b5ecd38.jpg";